// /home/oh33090489/real-estate-app/frontend/src/components/HoListOverlay.jsx

import React from "react";
import HoList from "./HoList";
import "./HoListOverlay.css"; // 👈 이 줄이 반드시 있어야 합니다.

export default function HoListOverlay({ open, items, onSelect, onClose }) {
  if (!open) return null;

  return (
    <div className="overlay">
      <div className="panel">
        <div className="header">
          <b>동일 소재지 호수 목록</b>
          <button onClick={onClose}>닫기</button>
        </div>
        <HoList
          items={items}
          onSelect={(it) => {
            onSelect(it);
            onClose();
          }}
        />
      </div>
    </div>
  );
}
